import { Table, TableProps } from "@mui/material";

export default (props: TableProps) => {
	return <Table {...props} />;
};
